export default __webpack_public_path__ + "static/media/invoice_blue.acb885ac.svg";